export default __webpack_public_path__ + "static/logo-78a77c17742f2f9d45c715c7645e054d.svg";